// Input
export enum IncomingMessage {
  StopAutoplay = '{"type":"Tilt"}',
}

// Output
export interface IOutgoingMessage {
  name: string;
  data?: string | object;
}
